export enum AttachDetachAction {
  DETACH_TRUCK = 'DETACH_TRUCK',
  DETACH_TRUCK_AND_TRAILER = 'DETACH_TRUCK_AND_TRAILER',
  DETACH_TRAILER = 'DETACH_TRAILER',
  DETACH_TRAILER_SEMI_TRAILER_TRUCK = 'DETACH_TRAILER_SEMI_TRAILER_TRUCK',
  ATTACH_TRUCK = 'ATTACH_TRUCK',
  ATTACH_TRAILER = 'ATTACH_TRAILER',
  TRAILER_SWAP = 'TRAILER_SWAP',
}
